module.exports = __webpack_public_path__ + "img/credit-card.efdf3ca3.png";